import { render, staticRenderFns } from "./HostDashboardUpcomingEvents.vue?vue&type=template&id=5453936c&"
import script from "./HostDashboardUpcomingEvents.vue?vue&type=script&lang=js&"
export * from "./HostDashboardUpcomingEvents.vue?vue&type=script&lang=js&"
import style0 from "./HostDashboardUpcomingEvents.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "HostDashboardUpcomingEvents.vue"
export default component.exports